<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p style="text-align: center;"><strong>Thanks and Appreciation</strong></p>
<p style="text-align: center;">To the wonderful lady who supports me and stays by my side. To my best friend, who provides me with love and passion, to my dearest sister. <strong>Nour Al-Huda Eitah</strong></p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2dffc9ca